module.exports = __webpack_public_path__ + "static/media/engineering0_old.8b6d541e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/department-module/unused/engineering0_old.jpg
// module id = 721
// module chunks = 0